module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-274.0ec2227.woff2";